<section>
  <div class="container mt-3">
    <form>

      <button class="btn btn-primary mb-3" type="button" (click)="nuevaSr()">Solicitar Retiro</button>
      <button class="btn btn-primary mb-3" type="button" *ngIf="sr.dni > 0 && listSrD.length > 0" (click)="imprimirEtiquetas()">Imprimir</button>
      <p *ngIf="sr.dni > 0 && listSrD.length === 0">el pedido no tiene bultos para imrpimir</p>
      <!-- <button class="btn btn-primary mb-3" type="button" (click)="nuevoUsuario()">Unirme como cliente</button> -->

      <div class="input-group mb-3">
        <span class="input-group-text" id="inputGroup-sizing-default">Numero de SR</span>
        <input id="SR" [(ngModel)]="filtro.id_sr" type="number" class="form-control"
          aria-label="SR" aria-describedby="inputGroup-sizing-default">
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text" id="inputGroup-sizing-default">Numero de ET</span>
        <input id="ET" [(ngModel)]="filtro.id_et" type="number" class="form-control"
          aria-label="ET" aria-describedby="inputGroup-sizing-default">
      </div>

      <button class="btn btn-primary" type="button" (click)="buscar()">Buscar</button>

      <table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark text-center">
        <thead class="table-dark">
          <tr>
            <th scope="col">Numero SR</th>
            <th scope="col">Numero ET</th>
            <th scope="col">Estado</th>
            <th scope="col">Motivo</th>
            <th scope="col">Fecha</th>
          </tr>
        </thead>
        <tbody class="table-light" *ngIf="estados!==undefined">
          <tr  *ngFor="let m of estados">
            <th >SR-{{m.id_sr| number:'6.0':'fr'}}</th>
            <th *ngIf="m.id_et!==null" >ET-{{m.id_et| number:'6.0':'fr'}}</th>
            <th *ngIf="m.id_et===null"></th>
            <th >{{m.estado_sr}}</th>
            <th >{{m.motivo}}</th>
            <th >{{m.fecha_estadosr}}</th>
          </tr>
        </tbody>
      </table>

    </form>
  </div>
</section>
